import { useState } from 'react';

import { IconPlus } from '@iwoca/icons';
import { Button } from '@iwoca/orion-ui';
import { FormattedMessage } from 'react-intl';

import { LinkDENewBankAccountModal } from '../../../../modals/addPaymentMethodModal/linkBankAccount/linkDENewBankAccount/LinkDENewBankAccount';
import StepItem from '../../stepItem/StepItem';

export const AddNewAccount = () => {
    const [isNewIbanModalOpen, setIsNewIbanModalOpen] = useState(false);

    return (
        <>
            <LinkDENewBankAccountModal
                isModalOpen={isNewIbanModalOpen}
                onClose={() => setIsNewIbanModalOpen(false)}
            />
            <StepItem
                title={
                    <FormattedMessage
                        id="_.funding_requirements.add_bank_details_title"
                        defaultMessage="Add your business bank details"
                    />
                }
                caption={
                    <FormattedMessage
                        id="_.funding_requirements.add_bank_details.add_new_funding_account_caption"
                        defaultMessage="For payout and direct debit"
                    />
                }
                action={
                    <Button
                        variant="primary"
                        onClick={() => setIsNewIbanModalOpen(true)}
                    >
                        <FormattedMessage
                            id="_.funding_requirements.add_bank_details.add_new_funding_account"
                            defaultMessage="Add now"
                        />
                        <IconPlus />
                    </Button>
                }
            />
        </>
    );
};
